// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__4b0Zt","additionalInfo":"AgreementModal_additionalInfo__2_eU8"};